import React, { Component } from 'react';
import { Form, actions } from 'react-redux-form';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import get from 'lodash/get';
import InterestSurvey from '../Forms/InterestSurvey';
import Identity from '../Forms/Identity';
import Address from '../Forms/Address';
import Contact from '../Forms/Contact';
import { persInfoPath } from '../Forms/Schemas/baseRrf';
import TrustedContact from '../Forms/TrustedContact';
import TrustedContactToggle from './TrustedContactToggle';

import TrustedContactInfo from '../TrustedContactInfo';

import Button from '../Button';
import './styles.css';

const validateTrustedContact = trustedContact => (
  trustedContact &&
  trustedContact.firstName &&
  trustedContact.lastName &&
  trustedContact.email &&
  trustedContact.telephone
);

// const debug = require('debug')('cambria:SignUp:PersonalInfo');


class PersonalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trustedContactActive: validateTrustedContact(props.trustedContact) || false,
    };
  }

  componentDidMount() {
    window.addEventListener('beforeunload', this.handleLeavePage);
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  onSubmit = async () => {
    this.props.onNext();
  };

  onTrustedContactButtonAdd = () => {
    this.setState({
      trustedContactActive: true,
    });
  };

  onTrustedContactButtonRemove = () => {
    this.props.resetTrustedContact();
    this.props.setPersonalInfoValidity();
    this.setState({
      trustedContactActive: false,
    });
  };

  handleLeavePage = (e) => {
    const { isPersonalInfoPristine } = this.props;
    if (!isPersonalInfoPristine) {
      e.preventDefault();
      e.returnValue = '';
    }
  };

  render() {
    const { authTokenUser } = this.props;
    if (!authTokenUser) {
      return <Redirect to="/login" push={false} />;
    }
    return (
      <div className="SignUpPersonalInfo">
        <Form
          model={persInfoPath}
          onSubmit={this.onSubmit}
        >
          <div styleName="instructions">What kind of deals are you looking for?</div>
          <div styleName="surveyContainer">
            <InterestSurvey surveyPath=".survey" />
          </div>
          <div styleName="instructions">We need some personal information so we can legally invest your money.</div>
          <div styleName="textInputs">
            <Identity identityPath=".identity" />
          </div>
          <div styleName="spaceBetweenFormGroups">
            <div styleName="instructions">How can we contact you with important materials?</div>
            <div styleName="textInputs">
              <Address addrPath=".identity.primaryAddress" required noPOBoxes />
              <Contact contactPath=".contact" />
            </div>
          </div>
          {/* Trusted Contact */}
          <div styleName="textInputs">
            <TrustedContactToggle
              onClick={
                this.state.trustedContactActive ?
                this.onTrustedContactButtonRemove : this.onTrustedContactButtonAdd
              }
              type={this.state.trustedContactActive ? 'remove' : 'add'}
            />
            {
              this.state.trustedContactActive ?
                <div styleName="trustedContactContainer">
                  <div styleName="trustedContactTitle">Trusted Contact Person (Optional)</div>
                  <TrustedContactInfo bottomBorder fontSize="11px" centered />
                  <TrustedContact addrPath=".trustedContact" />
                </div> : null
            }
          </div>
          <div styleName="submitButtonContainer">
            <Button type="submit">Continue</Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  trustedContact: state.rrSignupForms.personalInfo.trustedContact,
  isPersonalInfoPristine: get(state.rrSignupForms, 'forms.personalInfo.$form.pristine', true),
  isPersonalInfoValid: get(state.rrSignupForms, 'forms.personalInfo.$form.valid', false),
  authTokenUser: state.authTokenUser,
});

const mapDispatchToProps = dispatch => ({
  resetTrustedContact: () => (dispatch(actions.reset(`${persInfoPath}.trustedContact`))),
  setPersonalInfoValidity: validity => dispatch(actions.setValidity(`${persInfoPath}`, validity)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInfo);



// WEBPACK FOOTER //
// ./src/components/SignUp/PersonalInfoRrf.js